<template>
  <div v-loading="load" element-loading-text="等待完成支付" class="portlet">
    <div class="id-info">
        <div class="item">
            <span class="title">报考级别：</span>
            <select v-model="level">
                <option value ="0">EIFM 初级国际财务管理师</option>
                <option value ="1">AIFM 助理级国际财务管理师</option>
                <option value ="2">IFM 中级国际财务管理师</option>
                <option value ="3">SIFM 高级国际财务管理师</option>
                <option value ="4">继续教育</option>
            </select>
        </div>
        <!-- <div v-if="Number(level)===1" class="item">
            <span class="title">报考费用：</span>
            <span class="ver-info">RMB:{{Number(level)===1?'395':'495'}}元</span>
        </div>
        <div class="item" v-if="Number(level)===1">
            <span class="title">支付方式：</span>
            <img :class="type===1?'select':''" src="../../assets/zfbpay.png" @click="type=1">
            <img :class="type===2?'select':''" src="../../assets/wxpay.png" @click="type=2">
        </div> -->
    </div>
    <div class="step-btn" @click="next">下一步
        <i class="fa icon-arrow-right"/>
    </div>
    <el-dialog
        width="170"
        :title="'微信支付'"
        @close="closeCode"
        :visible.sync="innerVisible"
        append-to-body>
        <div class="paycode">
        <!-- 放置二维码的容器,需要给一个ref -->
            <div id="qrcode" style="width:150px;margin:auto" ref="qrcode"></div>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import axios from 'axios'
export default {
    data() {
        return {
            infoObj:{
                name:'身份证自动识别',
            },
            level:1,
            type:'',
            load:false,
            innerVisible:false,
            qr:'',
            aliPaySetInteval:'',
            wxPaySetInteval:''
        }
    },
    destroyed() {
        if(this.aliPaySetInteval !== ''){
            clearTimeout(this.aliPaySetInteval);
        }
        if(this.wxPaySetInteval !== ''){
            clearTimeout(this.wxPaySetInteval);
        }
    },
    methods: {
        async aliPay(){
            const params = {
                item_id:Number(this.level)-1,
                type :1,
                token:localStorage.getItem('tem_ifm_token')
            };
            const res = await axios.post('/api/pay/alipayInit?token='+localStorage.getItem('tem_ifm_token'),params);
            if(res.status === 200){
                console.log(res);
                this.load = true;
                let routerData = this.$router.resolve({path:'/zfb',query:{htmls:res.data}});
                window.open(routerData.href,'_blank');
                this.aliPaySetInteval = setInterval(() => {
                    if(localStorage.getItem('cfda_zfbpay')){
                        clearInterval(this.aliPaySetInteval);
                        this.load = false;
                        localStorage.removeItem('cfda_zfbpay')
                        this.paySuccess()
                    }
                }, 1000);
                
            }
        },
        async next(){
            // 缴费成功后将tem_ifm_token置为ifm_token
            localStorage.getItem('tem_ifm_token')&&localStorage.setItem('ifm_token',localStorage.getItem('tem_ifm_token'));
            localStorage.removeItem('tem_ifm_token');
            this.$emit('changeStep',{val:4,level:this.level});
        },
        async wxPay(){
            const params = {
                item_id:Number(this.level)-1,
                type :1,
                token:localStorage.getItem('tem_ifm_token')
            };
            this.load = true;
            const res = await axios.post('/api/pay/wechatInit?token='+localStorage.getItem('tem_ifm_token'),params);
            if(res.status === 200){
                this.load = false;
                console.log(res);
                this.innerVisible = true;
                this.$nextTick(() => {
                    this.qr = new QRCode('qrcode', {
                        width: 150,
                        height: 150, // 高度
                        text: res.data.data.url // 二维码内容
                    })
                })
                this.listenWxPayResult(res.data.data.order_no);
            }
        },
        paySuccess(){
            this.$toast('支付成功');
            const tem = setTimeout(() => {
                // 缴费成功后将tem_ifm_token置为ifm_token
                localStorage.getItem('tem_ifm_token')&&localStorage.setItem('ifm_token',localStorage.getItem('tem_ifm_token'));
                localStorage.removeItem('tem_ifm_token');
                this.$emit('changeStep',{val:4,level:this.level});
                clearTimeout(tem);
            }, 1500);
        },
        listenWxPayResult(no){
            this.wxPaySetInteval = setInterval(async() => {
                const params = {
                    order_no: no,
                    token:localStorage.getItem('tem_ifm_token')
                }
                const res = await this.$http.get('/api/pay/getPayStatus?token='+localStorage.getItem('tem_ifm_token'),params)
                if(res){
                    if(Number(res.pay_succ) === 1){
                        clearInterval(this.wxPaySetInteval);
                        this.paySuccess();
                        this.closeCode();
                        this.innerVisible = false;
                    }
                }
                
            }, 2000);
        },
        closeCode () {
            if(this.wxPaySetInteval !== ''){
                clearTimeout(this.wxPaySetInteval);
            }
            this.$refs.qrcode.innerHTML = ''
        }
    },
}
</script>
<style lang="scss" scoped>
@import '../../assets/user.scss';
.id-info{
    width:100%;
    padding-left: 15px;
    .item{
        margin-bottom: 25px;
        span{
            display: inline-block;
            vertical-align: middle;
        }
        select{
            width: 240px;
            height: 25px;
            margin-left: 5px;
        }
        .select{
            border:2px solid #002c56;
        }
        .title{
            text-align: right;
            width: 75px;
        }
        img{
            width: 76px;
            vertical-align: middle;
            border: 1px solid #dfdbdb;
            border-radius: 2px;
            margin-right: 25px;
            cursor: pointer;
        }
        .ver-info{
            width: 146px;
            height: 30px;
            line-height: 28px;
            margin-left: 5px;
            font-size: 16px;
            font-weight: 500;
        }
    }
}
</style>
